/**
 * Utility functions for logging that are conditionally enabled based on environment
 */

/**
 * Determines if detailed logging should be enabled
 * - Always false in production builds
 * - Can be controlled in dev/test environments
 */
export const isLoggingEnabled = (): boolean => {
  // Always disable in production mode
  if (import.meta.env.PROD === true) {
    return false;
  }
  
  // Only enable in development mode
  const isDev = import.meta.env.DEV === true;
  
  // Could also check for additional conditions like a localStorage flag
  // const debugFlagEnabled = localStorage.getItem('debug') === 'true';
  
  return isDev;
};

/**
 * Log info message only in development mode
 */
export const logInfo = (message: string, ...data: any[]): void => {
  if (isLoggingEnabled()) {
    console.log(message, ...data);
  }
};

/**
 * Log warning message only in development mode
 */
export const logWarn = (message: string, ...data: any[]): void => {
  if (isLoggingEnabled()) {
    console.warn(message, ...data);
  }
};

/**
 * Log error message in all environments
 * Use this only for actual errors that need attention
 */
export const logError = (message: string, error: any): void => {
  // We log errors in all environments but with different detail levels
  if (isLoggingEnabled()) {
    console.error(message, error);
  } else {
    // In production, log minimal information to avoid leaking sensitive data
    console.error(message);
    
    // Optionally send to error reporting service in production
    // if (errorReportingService) {
    //   errorReportingService.report(message, error);
    // }
  }
}; 